import { z } from 'zod';
import { baseSchema, baseFESchema } from '../base.domain.js';
import { questionSchema } from '../question/question.js';
import { objectIdSchema, isValidObjectIdSchema } from '../../utils/index.js';
import { quizVersionFESchema } from '../quiz-version/quiz-version.js';

var QuizType = /* @__PURE__ */ ((QuizType2) => {
  QuizType2["QUIZ"] = "quiz";
  QuizType2["LESSON"] = "presentation";
  QuizType2["VIDEO_QUIZ"] = "video-quiz";
  QuizType2["READING_QUIZ"] = "reading-quiz";
  return QuizType2;
})(QuizType || {});
const infoSchema = z.object({
  name: z.string().min(1).max(150),
  image: z.string().optional(),
  description: z.string().optional(),
  lang: z.string().optional(),
  visibility: z.boolean().optional(),
  subjects: z.array(z.string()).optional(),
  topics: z.array(z.string()).optional(),
  subtopics: z.array(z.string()).optional(),
  grade: z.array(z.string()).optional(),
  standardsData: z.record(z.string(), z.any()).optional(),
  gradeLevel: z.string().nullable().default(null),
  courses: z.array(objectIdSchema).optional(),
  questions: z.array(questionSchema).default([]),
  standards: z.array(objectIdSchema).default([]),
  standardIds: z.array(z.unknown()).default([]),
  traits: z.record(z.string(), z.any()).optional()
});
const infoFESchema = infoSchema.extend({
  courses: z.array(isValidObjectIdSchema).optional(),
  standards: z.array(isValidObjectIdSchema).optional(),
  standardIds: z.array(z.unknown()).optional()
});
const quizSchema = baseSchema.extend({
  createdBy: z.object({
    id: objectIdSchema,
    media: z.string().optional(),
    firstName: z.string(),
    lastName: z.string()
  }).optional(),
  premiumUse: z.enum(["ENABLED", "DISABLED"]).default("DISABLED").optional(),
  stats: z.object({
    played: z.number().int().default(0),
    totalPlayers: z.number().int().default(0),
    totalCorrect: z.number().int().default(0),
    totalQuestions: z.number().int().default(0)
  }).optional(),
  love: z.number().int().default(0).optional(),
  reviewed: z.boolean().default(false).optional(),
  cloned: z.boolean().default(false).optional(),
  parentDetail: z.object({
    quizId: objectIdSchema,
    userId: objectIdSchema
  }).nullable().default(null),
  meta: z.object({
    slot: z.number().optional(),
    experiment: z.string().optional()
  }),
  versions: z.array(objectIdSchema).default([]).optional(),
  deleted: z.boolean().default(false).optional(),
  v: z.number().int().default(1),
  draftVersion: objectIdSchema.nullable().optional(),
  publishedVersion: objectIdSchema.nullable().optional(),
  info: infoSchema,
  isShared: z.boolean().default(false).optional(),
  paidOrganization: objectIdSchema.optional(),
  organizationIds: z.array(objectIdSchema).default([]),
  type: z.nativeEnum(QuizType).default("quiz" /* QUIZ */),
  translatedTo: z.string().optional(),
  hasDraftVersion: z.boolean().optional(),
  draft: quizVersionFESchema.optional()
});
const quizFESchema = quizSchema.merge(baseFESchema.extend({
  createdBy: isValidObjectIdSchema,
  parentDetail: z.object({
    quizId: isValidObjectIdSchema,
    userId: isValidObjectIdSchema
  }).nullable().default(null),
  versions: z.array(isValidObjectIdSchema).default([]).optional(),
  commonAssessmentId: z.string().default("").optional(),
  draftVersion: isValidObjectIdSchema.nullable().optional(),
  publishedVersion: isValidObjectIdSchema.nullable().optional(),
  info: infoFESchema,
  paidOrganization: isValidObjectIdSchema.optional(),
  organizationIds: z.array(isValidObjectIdSchema).default([]),
  draft: quizVersionFESchema,
  hasPublishedVersion: z.boolean(),
  hasDraftVersion: z.boolean()
}));

export { QuizType, quizFESchema, quizSchema };
